import React, { Suspense } from 'react';
import ErrorBoundary from '../errorboundry';
import FallbackUI from '../fallbackUI';
import ContainerTab from "../../../commonComponents/ContainerTab/ContainerTab"
import ErrorMessagesWindow from '@commonComponents/errorValidationWindow';
import { useSelector } from 'react-redux';
import { useCurrentShipmentType } from '../../../hooks';
import { useValidationCDS } from '../../hooks/useValidationCDS';
import { cdsFieldPatterns } from '../../util/cdsFieldPattern';

const ContainerForm = (props) => {
    const ErrorWarningsList = useSelector((state) => state.ErrorValidationReducer?.containersTab) || []
    const containerList = useSelector((state) => state.containerReducer.containerList) || [];
    const containerErrors = useSelector(state=>state.ValidationErrors?.containers)
    const {isImportShipment}= useCurrentShipmentType()
    const fieldPattern  = cdsFieldPatterns(isImportShipment)
    const {validateError, updateError, initContainersTabValidationCDS} = useValidationCDS('containers')
    return (
      <ErrorBoundary>
        <Suspense fallback={<FallbackUI />}>
        {ErrorWarningsList?.length > 0 && !props.disabled && containerList?.length>0 && (
              <ErrorMessagesWindow errors={ErrorWarningsList} />
            )}
          <div>

          <ContainerTab 
            isImportShipment={isImportShipment} 
            errorInfo={containerErrors} 
            fieldPattern={fieldPattern}
            validateError={validateError}
            initContainersTabValidationCDS={initContainersTabValidationCDS}
          />

          </div>
        </Suspense>
      </ErrorBoundary>
    )
  }
  
  export default React.memo(ContainerForm)